<template>
  <div>
<!--    <div v-if="version === 'v1'">-->
<!--      <SpinVoucher/>-->
<!--    </div>-->
    <div v-if="version === 'v2'">
      <SpinGift/>
    </div>
    <div v-if="version === 'v3'">
      <SpinCarousel />
    </div>
  </div>
</template>

<script>

import SpinVoucher from "@/pages/version1/SpinVoucher.vue";
import SpinGift from "@/pages/version2/SpinGift.vue";
import SpinCarousel from "@/pages/version3/SpinCarousel.vue";

export default {
  name: 'App',
  components: {
    SpinCarousel,
    SpinGift,
    SpinVoucher
  },
  data() {
    return {
      version: 'v1'
    }
  },
  mounted() {
    this.version = process.env.VUE_APP_VERSION_CURRENT
  }
}
</script>
